import { useEffect, useState } from "react";
import {
  CaretDownIcon,
  BuildingIcon,
  MegaphoneIcon,
} from "@phosphor-icons/react";
import "./css/ContactUsPage.css";

function ContactUsPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, []);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setPhone(value);
    }
  };

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    setShowDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const formData = new FormData(e.target);

    const payload = new URLSearchParams({
      fullName: formData.get("name"),
      email: formData.get("email"),
      phone: phone,
      profileType: selectedType,
      projectDetails: formData.get("message"),
    });

    try {
      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbycE9WPH6zRk-VGBSwczdZ3GXxYejvrJiv43yx28VI7BqYKxDN3p7dxn8W4U5cv2z4J/exec",
        {
          method: "POST",
          body: payload, // 🚨 NO headers
        }
      );

      const result = await res.json();

      if (!result.success) throw new Error("Submission failed");

      setSubmitStatus({
        type: "success",
        message: "Message sent successfully!",
      });

      e.target.reset();
      setPhone("");
      setSelectedType("");
    } catch (err) {
      console.error(err);
      setSubmitStatus({
        type: "error",
        message: "Failed to send message. Try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };



  return (
    <div className="page-contact-root" id="contact">
      <div className="contact-grid">
        <div className="contact-content-sticky">
          <div className="contact-content-inner">
            <h1 className="contact-title">Ready to Monetize Your Audience?</h1>
            <p className="contact-description">
              Whether you're a media house looking to boost ad revenue or an
              advertiser seeking premium placements, we have the solutions.
              Let's discuss how we can create profitable partnerships that drive
              growth for your business.
            </p>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="cf-field">
            <label className="cf-label" htmlFor="name">
              Full Name*
            </label>
            <input
              id="name"
              name="name"
              type="text"
              className="cf-input"
              placeholder="John Doe"
              required
              autoComplete="name"
              disabled={isSubmitting}
            />
          </div>

          <div className="cf-field">
            <label className="cf-label" htmlFor="email">
              Email Address*
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="cf-input"
              placeholder="contact@gmail.com"
              required
              autoComplete="email"
              disabled={isSubmitting}
            />
          </div>

          <div className="cf-field">
            <label className="cf-label" htmlFor="phone">
              Phone Number*
            </label>
            <div className="phone-input-container">
              <div className="country-code">+91</div>
              <input
                id="phone"
                name="phone"
                type="tel"
                className="cf-input phone-input"
                placeholder="Enter 10-digit mobile number"
                value={phone}
                onChange={handlePhoneChange}
                required
                autoComplete="tel"
                disabled={isSubmitting}
                maxLength={10}
                pattern="[0-9]{10}"
              />
            </div>
            <div className="phone-hint">
              Enter your 10-digit mobile number without country code
            </div>
          </div>

          <div className="cf-field">
            <label className="cf-label">I am a*</label>
            <div className="dropdown-container">
              <button
                type="button"
                className={`dropdown-toggle ${selectedType ? "has-value" : ""
                  } ${showDropdown ? "active" : ""}`}
                onClick={() => setShowDropdown(!showDropdown)}
                disabled={isSubmitting}
              >
                <div className="dropdown-selected">
                  {selectedType ? (
                    <>
                      {selectedType === "Media House" ? (
                        <BuildingIcon size={18} className="dropdown-icon" />
                      ) : (
                        <MegaphoneIcon size={18} className="dropdown-icon" />
                      )}
                      <span>{selectedType}</span>
                    </>
                  ) : (
                    <span className="dropdown-placeholder">
                      Select your profile type
                    </span>
                  )}
                </div>
                <CaretDownIcon
                  size={16}
                  className={`dropdown-caret ${showDropdown ? "rotated" : ""}`}
                />
              </button>

              {showDropdown && (
                <div className="dropdown-menu">
                  <div
                    className={`dropdown-option ${selectedType === "Media House" ? "selected" : ""
                      }`}
                    onClick={() => handleTypeSelect("Media House")}
                  >
                    <BuildingIcon size={18} className="dropdown-icon" />
                    <div className="option-content">
                      <div className="option-title">Media House</div>
                      <div className="option-description">
                        News portals, publishers, content creators
                      </div>
                    </div>
                  </div>

                  <div
                    className={`dropdown-option ${selectedType === "Advertiser" ? "selected" : ""
                      }`}
                    onClick={() => handleTypeSelect("Advertiser")}
                  >
                    <MegaphoneIcon size={18} className="dropdown-icon" />
                    <div className="option-content">
                      <div className="option-title">Advertiser</div>
                      <div className="option-description">
                        Brands, agencies, marketing professionals
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <input type="hidden" name="type" value={selectedType} required />
          </div>

          <div className="cf-field">
            <label className="cf-label" htmlFor="message">
              Message*
            </label>
            <textarea
              id="message"
              name="message"
              className="cf-textarea"
              placeholder="Enter your message here..."
              rows={6}
              required
              disabled={isSubmitting}
            />
          </div>

          {submitStatus && (
            <div className={`submit-status ${submitStatus.type}`}>
              {submitStatus.message}
            </div>
          )}

          <button type="submit" className="cf-submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="loading-spinner"></span>
                Processing...
              </>
            ) : (
              "Send Message"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactUsPage;
